import axiosModule from 'axios';
import { StartKycCallback } from '@finn-no/tjt-common-node';
import { transformObjectToQueryParams } from '@finn-no/tjt-common-utils';


const axiosConfig = {
    timeout: 3000,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
};

const axios = axiosModule.create({ ...axiosConfig });

export const startKyc = async (callback: StartKycCallback, appBaseUrl: string, adId: string | undefined) => {
    const queryParams = transformObjectToQueryParams({callback, adId})

    return axios.post(`${appBaseUrl}/api/initiate-kyc?${queryParams}`);
};